export type BuilderCustomBuildDataType = {
  description: string
}

export const builderCustomBuildData: BuilderCustomBuildDataType[] = [
  {
    description:
      'Many integration platforms offer pre-built connectors to popular SaaS apps, but what if you need a niche or vertical-specific integration that is custom to your infrastructure?',
  },
  {
    description:
      'Using Connector Builder, your developer team can craft any customer-facing integration in just a few hours.',
  },
  {
    description:
      'All you need to do is get access to the specific API docs & start injecting it into our system.',
  },
]
